import { render } from "./VpcTiersTab.vue?vue&type=template&id=3f465d7e&scoped=true"
import script from "./VpcTiersTab.vue?vue&type=script&lang=js"
export * from "./VpcTiersTab.vue?vue&type=script&lang=js"

import "./VpcTiersTab.vue?vue&type=style&index=0&id=3f465d7e&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f465d7e"]])

export default __exports__